import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getTrendKPIsForAssetV2 } from '../../../commonActions';
import { getModel } from './selectors';
import * as actions from './actions';
import * as internalTabsActions from './InternalTabs/actions';
import TrendComponent from './TrendComponent';


const TrendContainer = (props) => {
    return <TrendComponent {...props} />;
};


export const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, ...internalTabsActions, getTrendKPIsForAssetV2 }, dispatch)
    };
};

const TrendContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(TrendContainer);


export default TrendContainerConn;
